module.exports = __webpack_public_path__ + "static/media/SFProText-Semibold.1a131c94.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProText-Semibold.ttf
// module id = 2552
// module chunks = 7